<template>
  <div class="col-lg-9 col-xlg-9 col-md-7">
    <div v-if="showWalletPart" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              My Wallet
            </h4>
            <h6 class="card-subtitle">
              Wallet information for the user.
            </h6>
          </div>
          <div class="card-body card-blue">
            <div class="form-group row">
              <div class="col-8 border-right">
                <template v-for="wal in walletList">
                  <div class="row p-b-20">
                    <div class="col-1">
                      <blockie :address="wal.address" class="blockie" />
                    </div>
                    <div class="col-10 m-t-5">
                      <span>{{ wal.address }}</span> &nbsp; <span :class="[wal.status === 'INACTIVE' ? 'hide': 'label label-success']">{{ wal.status }}</span>
                    </div>
                  </div>
                </template>
              </div>
              <div class="col-4 text-center">
                <h2 class="font-medium m-t-40 m-b-0">
                  <i class="fab fa-ethereum" /> &nbsp;1000
                </h2>
                <span class="text-muted">Active Account Balance</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              Purchase
            </h4>
            <h6 class="card-subtitle">
              Purchase USDB.
            </h6>
          </div>
          <!--<hr>-->
          <form class="form-horizontal">
            <div class="card-body card-blue">
              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label">Wallet Address</label>
                <div class="col-sm-9">
                  <multiselect id="address" v-model="wallet" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('address')}" :option-height="104" :options="walletList" :show-labels="false" class="form-control" data-vv-as="Wallet Address" label="title" name="address" placeholder="Select a Wallet" track-by="id">
                    <template slot="singleLabel" slot-scope="props">
                      <div class="row">
                        <div class="col-1">
                          <blockie :address="props.option.address" class="blockie" />
                        </div>
                        <div class="col-10">
                          <h3 class="font-normal m-t-15">
                            {{ props.option.address }}
                          </h3>
                        </div>
                      </div>
                    </template>
                    <template slot="option" slot-scope="props">
                      <div class="row">
                        <div class="col-1">
                          <blockie :address="props.option.address" class="blockie" />
                        </div>
                        <div class="col-6">
                          <h3 class="font-normal m-t-15">
                            {{ props.option.address }}
                          </h3>
                        </div>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label">Amount</label>
                <div class="col-sm-9">
                  <input id="amount" aria-invalid="false" aria-required="true" class="form-control" name="amount" pattern="\d*" placeholder="Token amount in USDB" type="number">
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="form-group m-b-0 text-right">
                <div class="button-group">
                  <button class="btn waves-effect waves-light btn-success" type="submit">
                    Purchase
                  </button>
                  <button class="btn waves-effect waves-light btn-secondary" type="button">
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-if="!showWalletPart" class="row">
      <div class="col-12 text-center">
        <div class="p-t-40">
          <h3 class="">
            You don't have any wallets added yet.
          </h3>
          <button class="btn btn-lg btn-stem" @click="addWallet()">
            <i class="fas fa-plus" />&nbsp; Add Wallet
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Blockie from '../common/Blockie'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'

export default {
  name: 'MyWallet',
  components: { Blockie, Multiselect },
  data () {
    return {
      wallet: null,
      walletList: [],
      submitted: false,
      showWalletPart: false
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  mounted () {
    this.getAllWallet()
  },
  methods: {
    async getAllWallet () {
      const reply = await this.$api.get('/wallets/user')
      this.walletList = reply.data
      if (this.walletList.length > 0) {
        this.showWalletPart = true
      } else {
        this.showWalletPart = false
      }
    },
    async addWallet () {
      await this.$api.put('/wallets/user')
      this.$toastr('success', 'User wallet successfully created.', 'Wallet Created')
      this.getAllWallet()
    }
  }
}
</script>

<style scoped>
.blockie {
  width: 50px;
}

.hide {
  display: none;
}
</style>
